import { render, staticRenderFns } from "./err404.vue?vue&type=template&id=bb33647e&scoped=true&"
import script from "./err404.vue?vue&type=script&lang=js&"
export * from "./err404.vue?vue&type=script&lang=js&"
import style0 from "./err404.vue?vue&type=style&index=0&id=bb33647e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb33647e",
  null
  
)

export default component.exports